import { render, staticRenderFns } from "./StudyIntroduction.vue?vue&type=template&id=dd30dc8c&scoped=true&"
import script from "./StudyIntroduction.vue?vue&type=script&lang=js&"
export * from "./StudyIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./StudyIntroduction.vue?vue&type=style&index=0&id=dd30dc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd30dc8c",
  null
  
)

export default component.exports